module.exports = __webpack_public_path__ + "static/media/cd2-icon-rejected.d7d9e049.svg";